
    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()


const videos = document.querySelectorAll('video[autoplay]')

var motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if(videos) {
     videos.forEach(function (video, index) {
    if (motionQuery.matches) {
        video.removeAttribute('autoplay')
        
      
    } else {
       
       
    }

    });    
   }

                    

}

motionQuery.addEventListener("change", handleReduceMotionChanged)

handleReduceMotionChanged(); // trigger once on load


document.addEventListener("DOMContentLoaded", function() {
  // Select the specific wrapper for your image
  const wrapper = document.querySelector('.ss-grid__item--Image.ss-grid-item__position--top.livro .ss-image-wrapper');
  
  if (wrapper) {
    wrapper.style.cursor = "pointer"; // Ensure the pointer style remains
    wrapper.addEventListener('click', function() {
      window.location.href = "https://www.livroreclamacoes.pt/Inicio/"; // Replace with your desired URL
    });
  }
});


